<template>
  <mdb-input
    :disabled="disabled"
    :id="`checkbox-rate-${row.map(r => r.rateData.rate.uuid).join('-')}`"
    :name="`checkbox-rate-${row.map(r => r.rateData.rate.uuid).join('-')}`"
    type="checkbox"
    v-model="checked"
  />
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mdbInput } from 'mdbvue'

export default {
  name: 'CalcRatesTableCellCheckbox',
  props: {
    row: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState('calc', {
      selected: state => state.selectedRates,
      client: state => state.query.client
    }),
    checked: {
      get () {
        return this.selected.includes(this.row.map(r => r.rateData.rate.uuid).join(','))
      },
      set (value) {
        this.setSelectedRate({uuid: this.row.map(r => r.rateData.rate.uuid).join(','), value: value})
      }
    },
    disabled: {
      get () {
        return !this.client && !this.checked && this.selected.length > 0
      }
    }
  },
  methods: {
    ...mapActions('calc', ['setSelectedRate'])
  },
  components: {
    mdbInput
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellCheckbox.vue